import { createContext, useContext, useState } from "react";
import axios from "axios";

axios.interceptors.request.use((config) => {
    const url = config.url || "";

    if (url.includes("/auth/login") || url.includes("/auth/resetPassword")) {
        if (config.headers) {
            delete config.headers.Authorization;
            delete config.headers.authorization;
        }
    }

    return config;
});

const AuthContext = createContext();

export const storeLocalData = (key, json, remember) => {
    const str = JSON.stringify(json);
    sessionStorage.setItem(key, str);
    if (remember) {
        localStorage.setItem(key, str);
    }
};

const fetchLocalData = (key) => {
    const sessionData = sessionStorage.getItem(key);
    if (sessionData) {
        return JSON.parse(sessionData);
    }

    const localData = localStorage.getItem(key);
    if (localData) {
        return JSON.parse(localData);
    }

    return undefined;
};

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(fetchLocalData("user"));
    const [token, setToken] = useState(fetchLocalData("token"));

    const signIn = async (formData, setLoginFailed) => {
        try {
            const username = formData.get("username").toLowerCase();
            const password = formData.get("password");
            const remember = Boolean(formData.get("remember"));

            const loginFormData = new FormData();
            loginFormData.append("username", username);
            loginFormData.append("password", password);

            const response = await axios.post("/auth/login", loginFormData, {
                withCredentials: false,
            });

            storeLocalData("user", response.data, remember);
            setUser(response.data);

            const auth = {
                username: username,
                password: password,
            };

            storeLocalData("token", auth, remember);
            setToken(auth);

            setLoginFailed(false);
        } catch (err) {
            setLoginFailed(true);
        }
    };

    const signOut = async () => {
        sessionStorage.clear();
        localStorage.clear();
        setUser(undefined);
        setToken(undefined);
    };

    return (
        <AuthContext.Provider value={{ user, token, setToken, signIn, signOut }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;

export const useAuth = () => useContext(AuthContext);
